import { create } from 'zustand';

import { LibraryResourceItem } from '../data/library-data';
import { LibraryModalType } from '../enum/library-modal-type.enum';

type OpenModalPayload = {
  onAcceptCallback?: () => void;
  onDismissCallback?: () => void;
  payload?: LibraryResourceItem | null;
  type: LibraryModalType;
};

type LibraryModalStoreState = {
  handleAccept: () => void;
  handleDismiss: () => void;
  isOpen: boolean;
  onAcceptCallback?: () => void;
  onDismissCallback?: () => void;
  openModal: (payload: OpenModalPayload) => void;
  payload: LibraryResourceItem | null;
  type: LibraryModalType;
};

const INITIAL_STATE: Omit<LibraryModalStoreState, 'handleAccept' | 'handleDismiss' | 'openModal'> =
  {
    isOpen: false,
    onAcceptCallback: undefined,
    onDismissCallback: undefined,
    payload: null,
    type: LibraryModalType.DOWNLOAD,
  };

export const LibraryModalStore = create<LibraryModalStoreState>()((set, get) => ({
  ...INITIAL_STATE,

  handleAccept: () => {
    const callback = get().onAcceptCallback;
    callback?.();
    set(INITIAL_STATE);
  },

  handleDismiss: () => {
    const callback = get().onDismissCallback;
    callback?.();
    set(INITIAL_STATE);
  },

  openModal: ({ onAcceptCallback, onDismissCallback, payload, type }) => {
    set({
      isOpen: true,
      onAcceptCallback,
      onDismissCallback,
      payload: payload ?? null,
      type,
    });
  },
}));
